export default __webpack_public_path__ + "static/media/logo.cdd00145.png";